import { FormDialog } from "../../components/FormDialog/FormDialog";

const ConnectorConfigDialog = ({ formId, readOnly, saveConnectorConfigData, uiSchema, connectorSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            uiSchema={uiSchema}
            schema={connectorSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveConnectorConfigData}
        />
    );

}

export default ConnectorConfigDialog;
